export const APPLY_COUPON_REQUEST = "APPLY_COUPON_REQUEST";
export const APPLY_COUPON_SUCCESS = "APPLY_COUPON_SUCCESS";
export const APPLY_COUPON_FAILURE = "APPLY_COUPON_FAILURE";

export const ALL_COUPON_REQUEST = "ALL_COUPON_REQUEST"
export const ALL_COUPON_SUCCESS = "ALL_COUPON_SUCCESS"
export const ALL_COUPON_FAIL = "ALL_COUPON_FAIL"

export const CLEAR_COUPON_STATE = "CLEAR_COUPON_STATE";
